import { useEffect, useState } from 'react';
import type { HappyHourView } from 'shared-models/browser';
import { isHappyHourEffective } from '../utils/happy-hour-window.util';

const TICK_MS = 30_000;

// Summary: re-derive whether the HH window is live now, on a 30s tick and on config change.
export function useHappyHourEffective(happyHour: HappyHourView | null): { effective: boolean } {
  const [effective, setEffective] = useState<boolean>(() => isHappyHourEffective(happyHour, new Date()));

  useEffect(() => {
    const evaluate = () => setEffective(isHappyHourEffective(happyHour, new Date()));
    evaluate();
    const timer = setInterval(evaluate, TICK_MS);
    return () => clearInterval(timer);
  }, [happyHour]);

  return { effective };
}
